import { Megaphone, Route, Package, Gamepad2, Gift, Store, GraduationCap, Briefcase, Users, Instagram, Youtube, Camera, Flame, Check } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Megaphone, Route, Package, Gamepad2, Gift, Store, GraduationCap, Briefcase, Users, Instagram, Youtube, Camera, Flame };

const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="glow-blob w-[30rem] h-[30rem] bg-purple-600/10 top-40 -left-52" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        caption="What We Do"
        title={<>Twelve ways we make your brand <span className="text-gradient">impossible to scroll past.</span></>}
        description="From the pavement to the feed — every service is engineered to create real-world moments and multiply them online."
        testId="services-heading"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.12}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group glass rounded-2xl p-7 h-full card-glow-hover relative overflow-hidden"
              >
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-gradient-to-br from-blue-600/15 to-purple-600/15 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="w-12 h-12 rounded-xl glow-border flex items-center justify-center mb-6">
                  <Icon className="w-5 h-5 text-indigo-300" />
                </div>
                <h3 className="font-display text-xl font-bold text-white tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.description}</p>
                <ul className="mt-5 space-y-2.5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-zinc-300">
                      <Check className="w-4 h-4 mt-0.5 text-indigo-400 shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
